__turbopack_context__.v({
  "bar": "MaskCard-module-scss-module__WocUfa__bar",
  "block-level": "MaskCard-module-scss-module__WocUfa__block-level",
  "block-level-control-label": "MaskCard-module-scss-module__WocUfa__block-level-control-label",
  "block-level-control-wrapper": "MaskCard-module-scss-module__WocUfa__block-level-control-wrapper",
  "block-level-label": "MaskCard-module-scss-module__WocUfa__block-level-label",
  "block-level-segmented-control": "MaskCard-module-scss-module__WocUfa__block-level-segmented-control",
  "block-level-setting": "MaskCard-module-scss-module__WocUfa__block-level-setting",
  "block-level-setting-description": "MaskCard-module-scss-module__WocUfa__block-level-setting-description",
  "blocked-stat": "MaskCard-module-scss-module__WocUfa__blocked-stat",
  "card": "MaskCard-module-scss-module__WocUfa__card",
  "copied-confirmation": "MaskCard-module-scss-module__WocUfa__copied-confirmation",
  "copy-button": "MaskCard-module-scss-module__WocUfa__copy-button",
  "copy-button-wrapper": "MaskCard-module-scss-module__WocUfa__copy-button-wrapper",
  "copy-icon": "MaskCard-module-scss-module__WocUfa__copy-icon",
  "deletion-button-wrapper": "MaskCard-module-scss-module__WocUfa__deletion-button-wrapper",
  "details": "MaskCard-module-scss-module__WocUfa__details",
  "details-wrapper": "MaskCard-module-scss-module__WocUfa__details-wrapper",
  "expand-button": "MaskCard-module-scss-module__WocUfa__expand-button",
  "forwarded-stat": "MaskCard-module-scss-module__WocUfa__forwarded-stat",
  "is-blocking-all": "MaskCard-module-scss-module__WocUfa__is-blocking-all",
  "is-blocking-none": "MaskCard-module-scss-module__WocUfa__is-blocking-none",
  "is-blocking-promotionals": "MaskCard-module-scss-module__WocUfa__is-blocking-promotionals",
  "is-disabled": "MaskCard-module-scss-module__WocUfa__is-disabled",
  "is-enabled": "MaskCard-module-scss-module__WocUfa__is-enabled",
  "is-focused": "MaskCard-module-scss-module__WocUfa__is-focused",
  "is-not-blocking-promotionals": "MaskCard-module-scss-module__WocUfa__is-not-blocking-promotionals",
  "is-not-removing-trackers": "MaskCard-module-scss-module__WocUfa__is-not-removing-trackers",
  "is-selected": "MaskCard-module-scss-module__WocUfa__is-selected",
  "label-editor-wrapper": "MaskCard-module-scss-module__WocUfa__label-editor-wrapper",
  "meta": "MaskCard-module-scss-module__WocUfa__meta",
  "onboarding-alias-container": "MaskCard-module-scss-module__WocUfa__onboarding-alias-container",
  "onboarding-closed": "MaskCard-module-scss-module__WocUfa__onboarding-closed",
  "onboarding-open": "MaskCard-module-scss-module__WocUfa__onboarding-open",
  "promo-selected": "MaskCard-module-scss-module__WocUfa__promo-selected",
  "promotions-locked-description-wrapper": "MaskCard-module-scss-module__WocUfa__promotions-locked-description-wrapper",
  "replies-stat": "MaskCard-module-scss-module__WocUfa__replies-stat",
  "stat": "MaskCard-module-scss-module__WocUfa__stat",
  "stats": "MaskCard-module-scss-module__WocUfa__stats",
  "summary": "MaskCard-module-scss-module__WocUfa__summary",
  "trackers-removed-stat": "MaskCard-module-scss-module__WocUfa__trackers-removed-stat",
  "without-chevron": "MaskCard-module-scss-module__WocUfa__without-chevron",
});
